import { EnvironmentProviders, inject, provideAppInitializer } from "@angular/core";
import { CustomIconLoaderService } from "../services/custom-icon-loader.service";

/**
 * Provides custom Material icon initialization.
 * Use this provider in both main.ts and Cypress component tests
 * to ensure consistent icon availability.
 *
 * @example
 * // In main.ts
 * bootstrapApplication(AppComponent, {
 *   providers: [
 *     provideCustomIcons(),
 *     // ...other providers
 *   ]
 * });
 *
 * @example
 * // In Cypress component tests
 * cy.mount(MyComponent, {
 *   providers: [
 *     provideCustomIcons(),
 *     // ...other providers
 *   ]
 * });
 */
export function provideCustomIcons(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const customIconLoader = inject(CustomIconLoaderService);
    customIconLoader.initializeIcons();
  });
}
